<template>
  <div>
    <div class="phone-selector-container-mobile">
      <div class="col" style="margin-bottom: 2rem;" v-if="$whitelabel.showLogo()">
        <img :src="require('../../assets/sqrql_logo.png')" width="160px" height="160px">
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;">
        <span v-if="$whitelabel.showBranding()">
          <a href="https://apps.apple.com/us/app/fractelfone/id1223367254?itsct=apps_box&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px; width: 250px; height: 83px;" v-if="getMobileOperatingSystem() !== 'Android'"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-US?size=250x83&amp;releaseDate=1491523200&h=bdf744cc4a35e3a02ea262a4b93c56a0" alt="Download on the App Store" style="border-radius: 13px; width: 250px; height: 83px;"></a>
          <a href='https://play.google.com/store/apps/details?id=com.fractel.fractelfone.android&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' v-if="getMobileOperatingSystem() !== 'iOS'"><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style="display: inline-block; overflow: hidden; border-radius: 13px; width: 250px; height: 83px;"/></a>
          <br /><br />
        </span>
        <router-link :to="{name: 'ResetEmail'}" style="color: #009AB1;">Forgot Password?</router-link>
        <br />
        <a v-if="$whitelabel.showUserGuide()" :href="$whitelabel.getUserGuideUrl()" style="color: #009AB1;">User Guide</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'mobileApp',
    methods: {
      getMobileOperatingSystem: function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
      }
    }
  }
</script>

<style scopped>
.phone-selector-container-mobile {
  background-color: white;
  padding: 20px !important;
  margin: 0 auto 0 auto !important;
  overflow: hidden;
  text-align: center !important;
}
.text-teal {
  color: #009AB1;
}
</style>
